import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocationSegments } from "../../../hooks/use-location-segments";
import { useAccountMenu } from "../../../hooks/use-account-menu";
export function useAccountMenuState() {
    const navigate = useNavigate();
    const { segments } = useLocationSegments();
    const { menuItems } = useAccountMenu();
    const { user: { user }, } = useSelector((state) => state.userState); //
    const [selected, setSelected] = useState(menuItems?.[0]);
    const fullName = useMemo(() => `${user?.name} ${user?.surname}`, [user]);
    const handleMenuItemClicked = useCallback((identifier) => () => {
        const target = menuItems?.find((item) => item?.identifier === identifier);
        if (target) {
            navigate(target?.url);
            setSelected(target);
        }
    }, [menuItems]);
    useEffect(() => {
        const firstSegment = segments?.[0];
        let currentMenuItem;
        switch (firstSegment) {
            case "orders":
                currentMenuItem = menuItems.find(({ identifier }) => identifier === "my-orders");
                break;
            case "account":
                currentMenuItem = menuItems.find(({ identifier }) => identifier === "account-details");
                break;
            case "addresses":
                currentMenuItem = menuItems.find(({ identifier }) => identifier === "my-addresses");
                break;
            default:
                return;
        }
        setSelected(currentMenuItem);
    }, [segments, menuItems]);
    return useMemo(() => ({
        fullName,
        selected,
        menuItems,
        handleMenuItemClicked,
    }), [fullName, selected, menuItems, handleMenuItemClicked]);
}
